import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { AppCurrencyPipe } from './app-currency.pipe';
import { MarkdownPipe } from './markdown.pipe';
import { I18nLabelPipe } from './i18n-label.pipe';

@NgModule({
  declarations: [FilterPipe, SearchPipe, ShortNamePipe, SafeUrlPipe, AppCurrencyPipe, MarkdownPipe, I18nLabelPipe],
  imports: [CommonModule],
  exports: [FilterPipe, SearchPipe, ShortNamePipe, SafeUrlPipe, AppCurrencyPipe, MarkdownPipe, I18nLabelPipe]
})

export class PipeModule { }
